mutation ConfirmUserImageUpload($input: ConfirmUserImageUploadInput!) {
  userImage: confirmUserImageUpload(input: $input) {
    id
    url
    fileId
  }
}
